<template functional>
  <SocialImage
    title="LinkedIn"
    v-bind="data.attrs"
    :class="[data.class, data.staticClass]"
    channel="linkedin"
    v-on="listeners"
  />
</template>

<script>
import SocialImage from './SocialImage';

export default {
  name: 'LinkedIn',
  components: {
    SocialImage,
  },
};
</script>
